import { AlertTriangle, X } from 'lucide-react'
import { useState } from 'react'
import { Button } from './ui/button'
import { getApiConfigStatus } from '@/api/client'

export function ConfigWarning() {
  const [dismissed, setDismissed] = useState(false)
  const configStatus = getApiConfigStatus()

  // Only show warning if VITE_API_BASE_URL is missing
  if (dismissed || configStatus.isValid) {
    return null
  }

  return (
    <div className="border-b border-yellow-500/50 bg-yellow-500/10 px-4 py-3">
      <div className="container mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 text-yellow-600 dark:text-yellow-500" />
          <div className="flex-1">
            <p className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
              Missing API Configuration
            </p>
            <p className="text-xs text-yellow-700 dark:text-yellow-300">
              Missing environment variable: VITE_API_BASE_URL. API calls will fail. Please set
              VITE_API_BASE_URL in your Cloudflare Pages settings or .env file.
            </p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 text-yellow-800 hover:bg-yellow-500/20 dark:text-yellow-200"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss warning"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
